import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm } from 'redux-form';
import { TextField } from '../../../../../components/fields';
import messages from '../../../../../text/messages';
import { formSettings } from './settings';
import { required } from '../../../../../utilities/validation';
import WizardButtons from '../../../../../components/wizard/navigator/buttons';
import { updateI9 } from '../../../../../reducers/i9s';
import { updateUserDetails, updateUserProfile } from '../../../../../reducers/identity';
import AddressComponent from '../../../../../components/address';

class PersonalInfoStep extends React.Component {
    constructor(props) {
        super(props);

        this.submit = this.submit.bind(this);
    }

    submit(values, action) {
        const { updateUserDetails, i9, updateUserProfile, profile } = this.props;
        const { firstName, lastName, witness_business_name, witness_job_title, street, street2, city, state, zip, country } = values;
        const i9Data = {
            witness_business_name,
            witness_job_title,
            witness_bizaddress_street: street2 ? `${street} ${street2}` : street,
            witness_bizaddress_city: city,
            witness_bizaddress_state: state,
            witness_bizaddress_postalcode: zip,
            witness_bizaddress_country: country
        };

        updateUserDetails({ type: 'i9', id: i9.id }, i9Data, () => updateUserProfile({ ...profile, first_name: firstName, last_name: lastName }, action));
    }

    render() {
        const { handleSubmit, onSubmit, submitting } = this.props;

        return (
            <form onSubmit={handleSubmit(values => this.submit(values, onSubmit))}>
                <div className="row">
                    <div className="col-xs-12 col-sm-9">
                        <div className="row">
                            <div className="col-xs-12 col-sm-6">
                                <Field name="firstName" validate={required} component={TextField} placeholder={messages.firstName} />
                            </div>
                            <div className="col-xs-12 col-sm-6">
                                <Field name="lastName" validate={required} component={TextField} placeholder={messages.lastName} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-xs-12 col-sm-6">
                                <Field name="witness_job_title" validate={required} component={TextField} placeholder={messages.witnessJobTitle} />
                            </div>
                            <div className="col-xs-12 col-sm-6">
                                <Field name="witness_business_name" validate={required} component={TextField} placeholder={messages.witnessBusinessName} />
                            </div>
                        </div>
                        <div className="row">
                            <AddressComponent form={formSettings.form} hideName={true} countries={{ US: 'active' }} oneLineAddress={true} />
                        </div>
                    </div>
                </div>

                <WizardButtons disabled={submitting} />
            </form>
        );
    }
}

PersonalInfoStep = reduxForm(formSettings)(PersonalInfoStep);
const mapStateToProps = (state, props) => {
    const profile = state.identity.profile;

    return {
        role: state.identity.role,
        profile,
        initialValues: { ...props.i9, firstName: profile.first_name, lastName: profile.last_name, country: 'US' }
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            updateI9,
            updateUserDetails,
            updateUserProfile
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(PersonalInfoStep);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/witness/steps/personalInfo.jsx